/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * TasksApi - axios parameter creator
 * @export
 */
export const TasksApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a new task.
         * @param {CreateTaskDto} createTaskDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskControllerCreate: (createTaskDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'createTaskDto' is not null or undefined
            assertParamExists('taskControllerCreate', 'createTaskDto', createTaskDto);
            const localVarPath = `/task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createTaskDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all tasks for a workspace.  Finished tasks are excluded — see buildFinishedTaskExclusion. This narrowed the response in APP-2191, for draft registrations only, and widened to every task type in APP-2299; the frontend is the only consumer and needs no change. Event handlers that must see completed tasks go through TaskService directly rather than this endpoint. The one exception is `includeResolved` on competing claims, which adds back those completed as Resolved.
         * @param {Array<string>} [clientIds] Only tasks whose own client (details.clientId) is one of these.
         * @param {string} [competingClaimId]
         * @param {Array<string>} [dueDates] Only tasks due on one of these UTC days (YYYY-MM-DD).
         * @param {boolean} [includeResolved] Competing claims only: also return completed tasks badged Resolved, the member\&#39;s resolved history (APP-2577). Ignored for other task types.
         * @param {Array<string>} [otherClaimants] Only competing-claim tasks against one of these other claimants. Each key is &#x60;otherWorkspaceId&#x60; (non-agent), &#x60;otherWorkspaceId.otherClientId&#x60; (agency client) or &#x60;otherWorkspaceId.&#x60; (agency, no client).
         * @param {string} [searchTerm] Case-insensitive text search across a task\&#39;s title fields (details.titles.title, details.claimTitle, description).
         * @param {Array<ConflictLevelsStatusEnum>} [statuses] Only tasks whose taskDisplayStatus is one of these.
         * @param {Array<string>} [titleIds] Filter tasks whose titleId is in this list — e.g. a client\&#39;s titles, for the MSR3 Clients Summary Tasks section (APP-2180). A single-id list also covers the MSR3 Title Summary Tasks section (APP-2092). Accepts a comma-separated string or repeated query params.
         * @param {TaskTypeEnum} [type]
         * @param {string} [workspaceId]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskControllerFindAll: (clientIds, competingClaimId, dueDates, includeResolved, otherClaimants, searchTerm, statuses, titleIds, type, workspaceId, page, pageSize, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (clientIds) {
                localVarQueryParameter['clientIds'] = clientIds;
            }
            if (competingClaimId !== undefined) {
                localVarQueryParameter['competingClaimId'] = competingClaimId;
            }
            if (dueDates) {
                localVarQueryParameter['dueDates'] = dueDates;
            }
            if (includeResolved !== undefined) {
                localVarQueryParameter['includeResolved'] = includeResolved;
            }
            if (otherClaimants) {
                localVarQueryParameter['otherClaimants'] = otherClaimants;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (statuses) {
                localVarQueryParameter['statuses'] = statuses;
            }
            if (titleIds) {
                localVarQueryParameter['titleIds'] = titleIds;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Distinct filter values on the workspace\'s open tasks of one type, plus resolved competing claims with `includeResolved`. Declared above `:id` so `filter-options` isn\'t captured as a task id.
         * @param {TaskTypeEnum} type
         * @param {string} workspaceId
         * @param {boolean} [includeResolved] Competing claims only: also draw values from completed tasks badged Resolved, so a resolved claim can be named and filtered (APP-2577). Ignored for other task types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskControllerFindFilterOptions: (type, workspaceId, includeResolved, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('taskControllerFindFilterOptions', 'type', type);
            // verify required parameter 'workspaceId' is not null or undefined
            assertParamExists('taskControllerFindFilterOptions', 'workspaceId', workspaceId);
            const localVarPath = `/task/filter-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (includeResolved !== undefined) {
                localVarQueryParameter['includeResolved'] = includeResolved;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (workspaceId !== undefined) {
                localVarQueryParameter['workspaceId'] = workspaceId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get task by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskControllerFindOne: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('taskControllerFindOne', 'id', id);
            const localVarPath = `/task/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a task by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskControllerRemove: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('taskControllerRemove', 'id', id);
            const localVarPath = `/task/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update an existing task.
         * @param {string} id
         * @param {UpdateTaskDto} updateTaskDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskControllerUpdate: (id, updateTaskDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('taskControllerUpdate', 'id', id);
            // verify required parameter 'updateTaskDto' is not null or undefined
            assertParamExists('taskControllerUpdate', 'updateTaskDto', updateTaskDto);
            const localVarPath = `/task/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateTaskDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TasksApi - functional programming interface
 * @export
 */
export const TasksApiFp = function (configuration) {
    const localVarAxiosParamCreator = TasksApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a new task.
         * @param {CreateTaskDto} createTaskDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskControllerCreate(createTaskDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.taskControllerCreate(createTaskDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all tasks for a workspace.  Finished tasks are excluded — see buildFinishedTaskExclusion. This narrowed the response in APP-2191, for draft registrations only, and widened to every task type in APP-2299; the frontend is the only consumer and needs no change. Event handlers that must see completed tasks go through TaskService directly rather than this endpoint. The one exception is `includeResolved` on competing claims, which adds back those completed as Resolved.
         * @param {Array<string>} [clientIds] Only tasks whose own client (details.clientId) is one of these.
         * @param {string} [competingClaimId]
         * @param {Array<string>} [dueDates] Only tasks due on one of these UTC days (YYYY-MM-DD).
         * @param {boolean} [includeResolved] Competing claims only: also return completed tasks badged Resolved, the member\&#39;s resolved history (APP-2577). Ignored for other task types.
         * @param {Array<string>} [otherClaimants] Only competing-claim tasks against one of these other claimants. Each key is &#x60;otherWorkspaceId&#x60; (non-agent), &#x60;otherWorkspaceId.otherClientId&#x60; (agency client) or &#x60;otherWorkspaceId.&#x60; (agency, no client).
         * @param {string} [searchTerm] Case-insensitive text search across a task\&#39;s title fields (details.titles.title, details.claimTitle, description).
         * @param {Array<ConflictLevelsStatusEnum>} [statuses] Only tasks whose taskDisplayStatus is one of these.
         * @param {Array<string>} [titleIds] Filter tasks whose titleId is in this list — e.g. a client\&#39;s titles, for the MSR3 Clients Summary Tasks section (APP-2180). A single-id list also covers the MSR3 Title Summary Tasks section (APP-2092). Accepts a comma-separated string or repeated query params.
         * @param {TaskTypeEnum} [type]
         * @param {string} [workspaceId]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskControllerFindAll(clientIds, competingClaimId, dueDates, includeResolved, otherClaimants, searchTerm, statuses, titleIds, type, workspaceId, page, pageSize, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.taskControllerFindAll(clientIds, competingClaimId, dueDates, includeResolved, otherClaimants, searchTerm, statuses, titleIds, type, workspaceId, page, pageSize, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Distinct filter values on the workspace\'s open tasks of one type, plus resolved competing claims with `includeResolved`. Declared above `:id` so `filter-options` isn\'t captured as a task id.
         * @param {TaskTypeEnum} type
         * @param {string} workspaceId
         * @param {boolean} [includeResolved] Competing claims only: also draw values from completed tasks badged Resolved, so a resolved claim can be named and filtered (APP-2577). Ignored for other task types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskControllerFindFilterOptions(type, workspaceId, includeResolved, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.taskControllerFindFilterOptions(type, workspaceId, includeResolved, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get task by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskControllerFindOne(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.taskControllerFindOne(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete a task by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskControllerRemove(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.taskControllerRemove(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update an existing task.
         * @param {string} id
         * @param {UpdateTaskDto} updateTaskDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskControllerUpdate(id, updateTaskDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.taskControllerUpdate(id, updateTaskDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * TasksApi - factory interface
 * @export
 */
export const TasksApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TasksApiFp(configuration);
    return {
        /**
         *
         * @summary Create a new task.
         * @param {CreateTaskDto} createTaskDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskControllerCreate(createTaskDto, options) {
            return localVarFp
                .taskControllerCreate(createTaskDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all tasks for a workspace.  Finished tasks are excluded — see buildFinishedTaskExclusion. This narrowed the response in APP-2191, for draft registrations only, and widened to every task type in APP-2299; the frontend is the only consumer and needs no change. Event handlers that must see completed tasks go through TaskService directly rather than this endpoint. The one exception is `includeResolved` on competing claims, which adds back those completed as Resolved.
         * @param {Array<string>} [clientIds] Only tasks whose own client (details.clientId) is one of these.
         * @param {string} [competingClaimId]
         * @param {Array<string>} [dueDates] Only tasks due on one of these UTC days (YYYY-MM-DD).
         * @param {boolean} [includeResolved] Competing claims only: also return completed tasks badged Resolved, the member\&#39;s resolved history (APP-2577). Ignored for other task types.
         * @param {Array<string>} [otherClaimants] Only competing-claim tasks against one of these other claimants. Each key is &#x60;otherWorkspaceId&#x60; (non-agent), &#x60;otherWorkspaceId.otherClientId&#x60; (agency client) or &#x60;otherWorkspaceId.&#x60; (agency, no client).
         * @param {string} [searchTerm] Case-insensitive text search across a task\&#39;s title fields (details.titles.title, details.claimTitle, description).
         * @param {Array<ConflictLevelsStatusEnum>} [statuses] Only tasks whose taskDisplayStatus is one of these.
         * @param {Array<string>} [titleIds] Filter tasks whose titleId is in this list — e.g. a client\&#39;s titles, for the MSR3 Clients Summary Tasks section (APP-2180). A single-id list also covers the MSR3 Title Summary Tasks section (APP-2092). Accepts a comma-separated string or repeated query params.
         * @param {TaskTypeEnum} [type]
         * @param {string} [workspaceId]
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskControllerFindAll(clientIds, competingClaimId, dueDates, includeResolved, otherClaimants, searchTerm, statuses, titleIds, type, workspaceId, page, pageSize, sortBy, options) {
            return localVarFp
                .taskControllerFindAll(clientIds, competingClaimId, dueDates, includeResolved, otherClaimants, searchTerm, statuses, titleIds, type, workspaceId, page, pageSize, sortBy, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Distinct filter values on the workspace\'s open tasks of one type, plus resolved competing claims with `includeResolved`. Declared above `:id` so `filter-options` isn\'t captured as a task id.
         * @param {TaskTypeEnum} type
         * @param {string} workspaceId
         * @param {boolean} [includeResolved] Competing claims only: also draw values from completed tasks badged Resolved, so a resolved claim can be named and filtered (APP-2577). Ignored for other task types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskControllerFindFilterOptions(type, workspaceId, includeResolved, options) {
            return localVarFp
                .taskControllerFindFilterOptions(type, workspaceId, includeResolved, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get task by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskControllerFindOne(id, options) {
            return localVarFp
                .taskControllerFindOne(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a task by Id.
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskControllerRemove(id, options) {
            return localVarFp
                .taskControllerRemove(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update an existing task.
         * @param {string} id
         * @param {UpdateTaskDto} updateTaskDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskControllerUpdate(id, updateTaskDto, options) {
            return localVarFp
                .taskControllerUpdate(id, updateTaskDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * TasksApi - object-oriented interface
 * @export
 * @class TasksApi
 * @extends {BaseAPI}
 */
export class TasksApi extends BaseAPI {
    /**
     *
     * @summary Create a new task.
     * @param {CreateTaskDto} createTaskDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    taskControllerCreate(createTaskDto, options) {
        return TasksApiFp(this.configuration)
            .taskControllerCreate(createTaskDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all tasks for a workspace.  Finished tasks are excluded — see buildFinishedTaskExclusion. This narrowed the response in APP-2191, for draft registrations only, and widened to every task type in APP-2299; the frontend is the only consumer and needs no change. Event handlers that must see completed tasks go through TaskService directly rather than this endpoint. The one exception is `includeResolved` on competing claims, which adds back those completed as Resolved.
     * @param {Array<string>} [clientIds] Only tasks whose own client (details.clientId) is one of these.
     * @param {string} [competingClaimId]
     * @param {Array<string>} [dueDates] Only tasks due on one of these UTC days (YYYY-MM-DD).
     * @param {boolean} [includeResolved] Competing claims only: also return completed tasks badged Resolved, the member\&#39;s resolved history (APP-2577). Ignored for other task types.
     * @param {Array<string>} [otherClaimants] Only competing-claim tasks against one of these other claimants. Each key is &#x60;otherWorkspaceId&#x60; (non-agent), &#x60;otherWorkspaceId.otherClientId&#x60; (agency client) or &#x60;otherWorkspaceId.&#x60; (agency, no client).
     * @param {string} [searchTerm] Case-insensitive text search across a task\&#39;s title fields (details.titles.title, details.claimTitle, description).
     * @param {Array<ConflictLevelsStatusEnum>} [statuses] Only tasks whose taskDisplayStatus is one of these.
     * @param {Array<string>} [titleIds] Filter tasks whose titleId is in this list — e.g. a client\&#39;s titles, for the MSR3 Clients Summary Tasks section (APP-2180). A single-id list also covers the MSR3 Title Summary Tasks section (APP-2092). Accepts a comma-separated string or repeated query params.
     * @param {TaskTypeEnum} [type]
     * @param {string} [workspaceId]
     * @param {number} [page] The page number to retrieve, default &#x3D; 1
     * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
     * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    taskControllerFindAll(clientIds, competingClaimId, dueDates, includeResolved, otherClaimants, searchTerm, statuses, titleIds, type, workspaceId, page, pageSize, sortBy, options) {
        return TasksApiFp(this.configuration)
            .taskControllerFindAll(clientIds, competingClaimId, dueDates, includeResolved, otherClaimants, searchTerm, statuses, titleIds, type, workspaceId, page, pageSize, sortBy, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Distinct filter values on the workspace\'s open tasks of one type, plus resolved competing claims with `includeResolved`. Declared above `:id` so `filter-options` isn\'t captured as a task id.
     * @param {TaskTypeEnum} type
     * @param {string} workspaceId
     * @param {boolean} [includeResolved] Competing claims only: also draw values from completed tasks badged Resolved, so a resolved claim can be named and filtered (APP-2577). Ignored for other task types.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    taskControllerFindFilterOptions(type, workspaceId, includeResolved, options) {
        return TasksApiFp(this.configuration)
            .taskControllerFindFilterOptions(type, workspaceId, includeResolved, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get task by Id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    taskControllerFindOne(id, options) {
        return TasksApiFp(this.configuration)
            .taskControllerFindOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a task by Id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    taskControllerRemove(id, options) {
        return TasksApiFp(this.configuration)
            .taskControllerRemove(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update an existing task.
     * @param {string} id
     * @param {UpdateTaskDto} updateTaskDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    taskControllerUpdate(id, updateTaskDto, options) {
        return TasksApiFp(this.configuration)
            .taskControllerUpdate(id, updateTaskDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
